// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"543c446b","732":"dccbbde5"}[chunkId] + ".chunk.js";
};